import { Component, input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-error-min',
  templateUrl: './error-min.html',
  styleUrl: './error-min.scss',
})
export class ErrorMinComponent implements OnInit {
  formCtrl = input.required<FormControl<any>>();
  errorMsg = '';

  ngOnInit(): void {
    const ctrl = this.formCtrl();
    if (ctrl?.errors?.['min']) {
      const minVal = ctrl.errors['min']?.min;
      this.errorMsg = `The value must be greater than or equal to ${minVal}`;
    }
  }
}
